import { onScroll } from './requestAnimationFrame';
import {
    inView,
    getPercentLocOfView,
    getRect,
    myTopAboveViewTop,
    myBottomAboveViewBottom,
} from './inViewNew';
import anime from 'animejs/lib/anime.es.js';

let scenes = [];
let animPresets = {};
let animPresetClass = 'anim';

const baseAnim = () => {
    return {
        el: null,
        timelines: [],
    };
};

// return value of data-anim-preset
const getAnimPreset = (el) => el.getAttribute('data-anim-preset') || '';

// Force a value between min and max
const clamp = (val, min, max) => (val > max ? max : val < min ? min : val);

// return decimal percent of location of item in view
const getScrollPercentOfRange = (el, top, bottom) => {
    const topLoc = getRect(el).top;
    const start = getPercentLocOfView(top);
    const end = getPercentLocOfView(bottom);
    const range = end - start;
    return clamp((topLoc - start) / range, 0, 1);
};

// bind css classes to handle position fixed/relative to handle "sticky" items
const setInViewClasses = (el) => {
    if (myTopAboveViewTop(el)) {
        el.classList.add('inview--top-top');
    } else {
        el.classList.remove('inview--top-top');
    }

    if (myBottomAboveViewBottom(el)) {
        el.classList.add('inview--bottom-bottom');
    } else {
        el.classList.remove('inview--bottom-bottom');
    }
};

// on each frame update all timelines in all scenes
const animTick = () => {
    scenes.forEach(function (scene) {
        let el = scene.el;
        if (inView(el)) {
            setInViewClasses(el);
            scene.timelines.forEach(function (timeline) {
                const percent = getScrollPercentOfRange(
                    el,
                    timeline.start,
                    timeline.end
                );
                timeline.timeline.seek(timeline.timeline.duration * percent);
            });
        }
    });
};


// Expose AnimeJs when registering new scenes & presets 
export const animeJs = anime;

// feed in an el to track scrolling position and timelineFn
export const addScene = (el, timelineFn) => {
    scenes.push(timelineFn({ ...baseAnim(), el }));
};

// Helper function to register dom elements with data-anim-preset value that is equal to a timelineFN in presets
export const registerPresets = (cssClass = animPresetClass, presets = {}) => {
    // Find elements with class name
    let animTargets = document.getElementsByClassName(cssClass);
    // Update internal presets with with items provided
    animPresets = { ...animPresets, ...presets };

    if (animTargets.length > 0) {
        // iterate over DOM results and add scenes to internal array
        Array.prototype.forEach.call(animTargets, function (el, i) {
            // test for 'data-anim-preset' on dom element. If we have a match in animation then register the animation
            let preset = getAnimPreset(el);
            if (animPresets[preset]) {
                addScene(el, animPresets[preset]);
            }
        });
    }
};

// register the on frame
onScroll(animTick);

// Some default animations

/*
 * animWidenOut
 *
 * <div class="anim" data-anim-preset="animWidenOut">
 *    <div style="width: 100vw; background: red;">
 *       <h1>Hi</h1>
 *    </div>
 * </div>
 */
export const animWidenOut = (sceneConfig) => {
    // Widen out the frame animation
    let widenOutTimeline = anime.timeline({ autoplay: false, loop: true });

    sceneConfig.el.style['margin-left'] = 'auto';
    sceneConfig.el.style['margin-right'] = 'auto';
    sceneConfig.el.style['overflow'] = 'hidden';
    sceneConfig.el.style['display'] = 'flex';
    sceneConfig.el.style['align-items'] = 'center';
    sceneConfig.el.style['justify-content'] = 'center';

    anime.set(sceneConfig.el, {
        width: '20vw',
    });

    widenOutTimeline.add({
        targets: sceneConfig.el,
        easing: 'linear',
        width: '100vw',
    });

    sceneConfig.timelines.push({
        start: 0.5,
        end: 0.1,
        timeline: widenOutTimeline,
    });

    return sceneConfig;
};
